import Sidebar from "../../components/sidebar/Sidebar";
import Topbar from "../../components/topbar/Topbar";
import style from "./Home.module.css";
import { useContext, useEffect, useState } from "react";
import FrequenciaApi from "../../services/FrequenciaApi";
import GraficoRadar from "../../components/graficoRadar/GraficoRadar";
import { useLocation, useNavigate } from "react-router-dom";
import Alerta from "../../components/alerta/Alerta";
import { Alert } from "react-bootstrap";
import BotaoProgresso from "../../components/botaoProgresso/BotaoProgresso";
import AvaliacaoApi from "../../services/AvaliacaoApi";
import { useIsMobile } from "../../components/useIsMobile/UseIsMobile";
import HomeApi from "../../services/HomeApi";
import MoodleAuthApi from "../../services/MoodleAuthApi";
import Cookies from "js-cookie";


function Home() {
  const isMobile = useIsMobile();
  const [menuHamburguerAberto, setMenuHamburguerAberto] = useState(!isMobile);

  useEffect(() => {
    setMenuHamburguerAberto(!isMobile);
  }, [isMobile]);

  //modle

  const [modle, setModle] = useState([])
  const [carregandoCurso, setCarregandoCurso] = useState(null)


  const [horasTotais, setHorasTotais] = useState('');
  const [horasMensais, setHorasMensais] = useState(null);
  const [horasSemanais, setHorasSemanais] = useState(null);
  const [avaliacaoCompleta, setAvaliacaoCompleta] = useState(null);
  const [exibirAvaliacoes, setExibirAvaliacoes] = useState(false);


  //Alerts
  const [mensagemAlerta, setMensagemAlerta] = useState("Logado Com Sucesso");
  const [tipoAlerta, setTipoAlerta] = useState("success");
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const feedbackFake = {
    positivos: [
      'Boa comunicação com os alunos',
      'Pontualidade nas entregas',
      'Domínio do conteúdo'
    ],
    aMelhorar: [
      'Melhorar a didática nas explicações técnicas',
      'Acompanhar mais de perto os alunos com dificuldade'
    ],
    direcionadores: [
      'Incluir mais exemplos práticos nas aulas',
      'Investir em estratégias de engajamento'
    ]
  };

  async function BuscarHoras() {
    try {
      const todasHoras = await FrequenciaApi.obterHorasFrequencias();
      setHorasTotais(todasHoras.horaTotal);
      setHorasMensais(todasHoras.horaMensal);
      setHorasSemanais(todasHoras.horaSemana);
    } catch (error) {
      console.error("Erro ao buscar as horas de frequência");
    }
  }

  function FormatarDataAcessos(dataISO) {
    const data = new Date(dataISO);
    const agora = new Date();

    const mesmaData = (d1, d2) =>
      d1.getDate() === d2.getDate() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getFullYear() === d2.getFullYear();

    const ontem = new Date();
    ontem.setDate(agora.getDate() - 1);

    let prefixo;
    if (mesmaData(data, agora)) {
      prefixo = "Hoje";
    } else if (mesmaData(data, ontem)) {
      prefixo = "Ontem";
    } else {
      prefixo = data.toLocaleDateString('pt-BR');
    }

    const hora = data.toLocaleTimeString('pt-BR', {
      hour: '2-digit',
      minute: '2-digit'
    });

    return `${prefixo} às ${hora}`;
  }

  function FormatarDataMensal(data) {
    const [ano, mes] = data.split("-");
    const meses = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];
    return `${meses[parseInt(mes) - 1]}/${ano}`;
  }

  function FormatarDataSemanal(periodo) {
    const meses = ["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"];

    const [inicio, fim] = periodo.split(" à ");
    const [anoInicio, mesInicio, diaInicio] = inicio.split("-");
    const [anoFim, mesFim, diaFim] = fim.split("-");

    const inicioFormatado = `${diaInicio}/${meses[parseInt(mesInicio) - 1]}`;
    const fimFormatado = `${diaFim}/${meses[parseInt(mesFim) - 1]}`;

    return `${inicioFormatado} à ${fimFormatado}`;
  }

  async function ObterAvalicaoIdMaisRecentePorAluno() {
    try {

      setAvaliacaoCompleta(null);
      setExibirAvaliacoes(false);

      const avaliacaoRecente = await AvaliacaoApi.ObterAvalicaoIdMaisRecentePorAluno();
      const avaliacao = await AvaliacaoApi.ObterAvaliacaoCompleta(avaliacaoRecente.id);

      setAvaliacaoCompleta(avaliacao);
      setExibirAvaliacoes(avaliacaoRecente.tipoAvaliacaoEnum === 1);


    } catch (error) {
      setExibirAvaliacoes(false);
      setAvaliacaoCompleta(null);
      console.error("Erro ao obter a avaliação mais recente:", error);
    }
  }


  async function ObterProgressoCursoModdle() {
    try {
      const progressoModle = await HomeApi.ListarProgressoCursosModle();
      setModle(progressoModle.cursos)

    } catch (error) {
      console.error("erro")
    }

  }

  async function handleCursoClick(curso) {
    setCarregandoCurso(curso.id);

    try {
      const moodleToken = await MoodleAuthApi.autenticarMoodle();

      if (moodleToken && moodleToken.token) {
        Cookies.set('moodle_token', moodleToken.token, {
          expires: 1 / 6,
          secure: true,
          sameSite: 'strict'
        });
      }

      const cursoUrl = `https://cursos.itera360.com.br/course/view.php?id=${curso.id}`;
      window.open(cursoUrl, '_blank');

    } catch (error) {
      console.error('Erro ao autenticar no Moodle:', error);
      const cursoUrl = `https://cursos.itera360.com.br/course/view.php?id=${curso.id}`;
      window.open(cursoUrl, '_blank');
    } finally {
      setCarregandoCurso(null);
    }
  }


  useEffect(() => {
    BuscarHoras();
    ObterAvalicaoIdMaisRecentePorAluno();
    ObterProgressoCursoModdle();
  }, [])

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const alertParam = params.get("alert");

    if (alertParam === "logado_sucesso") {
      setMensagemAlerta("Logado com sucesso!");
      setTipoAlerta("success");

      // Aguarda o próximo ciclo de renderização para aplicar classe de alerta
      setTimeout(() => {
        setMostrarAlerta(true);
      }, 100); // um pequeno delay

      params.delete("alert");
      navigate({ search: params.toString() }, { replace: true });

      setTimeout(() => setMostrarAlerta(false), 3000);
    }
  }, [location, navigate]);


  return (
    <>
      <Topbar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
        <Sidebar menuHamburguerAberto={menuHamburguerAberto} setMenuHamburguerAberto={setMenuHamburguerAberto}>
          <div className={style.pagina_conteudo}>

            <div className={style.alertLogado}>
              {mostrarAlerta && (
                <Alert
                  variant={tipoAlerta}
                  onClose={() => setMostrarAlerta(false)}
                  dismissible
                  className={style.alertaBaixoDireito}
                >
                  {mensagemAlerta}
                </Alert>

              )}

            </div>
            <div className={style.container_home} >
              <div className={style.container_superior} >
                <h2 className={style.titulo}>Horas de curso</h2>
                <div className={style.horas}>
                  <div className={style.card_horas}>
                    <span className={style.tipo_horas}>Total</span>
                    <span className={style.valor_horas}>{horasTotais} / 580h</span>
                    <div className={style.barra_container_horas}>
                      <div
                        className={style.barra_progresso_horas}
                        style={{ width: `${(horasTotais / 580) * 100}%` }}
                      />
                    </div>
                  </div>
                  <div className={style.card_horas}>
                    <span className={style.tipo_horas}>Mensal</span>
                    <span className={style.valor_horas}>{horasMensais?.horas}h</span>
                    <span className={style.data_horas}>Período: {horasMensais?.dataCorrespondente && FormatarDataMensal(horasMensais.dataCorrespondente)}</span>
                  </div>
                  <div className={style.card_horas}>
                    <span className={style.tipo_horas}>Semanal</span>
                    <span className={style.valor_horas}>{horasSemanais?.horas}h</span>
                    <span className={style.data_horas}>Período: {horasSemanais?.dataCorrespondente && FormatarDataSemanal(horasSemanais.dataCorrespondente)}</span>
                  </div>
                </div>

              </div>
              <div className={style.container_inferior}>
                <div
                  className={
                    exibirAvaliacoes
                      ? style.container_cursos
                      : `${style.container_cursos} ${style.semGrafico}`
                  }
                >
                  <h2 className={style.titulo_avaliacao}>Cursos</h2>
                  <div className={style.grid}>
                    {modle.length > 0 ? (
                      modle.map((cursos, index) => (
                        <div
                          key={index}
                          className={`${style.card_curso} ${style.card_curso_clicavel} ${carregandoCurso === cursos.id ? style.carregando : ''}`}
                          onClick={() => handleCursoClick(cursos)}
                        >
                          <h2 className={style.nome_modulo}>{cursos.fullname}</h2>
                          <BotaoProgresso value={cursos.progress ?? 0} />
                        </div>
                      ))
                    ) : (
                      <div className={`${style.card_curso} ${style.card_vazio}`}>
                        <h2 className={style.nome_modulo}>Nenhum curso disponível</h2>
                      </div>
                    )}
                  </div>
                </div>

                {exibirAvaliacoes && (
                  <div className={style.container_avaliacoes} >
                    <div className={style.feedback} >
                      <h2 className={style.titulo_avaliacao}>Última avaliação</h2>
                      <div className={style.feedbackGrid}>
                        <div className={style.card}>
                          <h3>Pontos Positivos</h3>
                          {avaliacaoCompleta?.pontosPositivos || ""}
                        </div>
                        <div className={style.card}>
                          <h3>Pontos a Melhorar</h3>
                          {avaliacaoCompleta?.pontosEvolucao || ""}
                        </div>
                        <div className={style.card}>
                          <h3>Direcionadores</h3>
                          {avaliacaoCompleta?.direcionadores || ""}
                        </div>
                      </div>
                    </div>
                    <div className={style.avaliacao} >
                      <div className={style.grafico}>
                        <GraficoRadar
                          labels={avaliacaoCompleta?.criterios.map((criterio) => criterio.nomeCriterio) || []}
                          data={avaliacaoCompleta?.criterios.map(
                            (criterio) => criterio.pontosCriterios[0]?.nota || 0
                          ) || []}
                        />
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </Sidebar>
      </Topbar >
    </>
  );
}

export default Home;
